<template>
  <span class="link-cell-renderer">
    <router-link
      v-if="params.to"
      :id="uid"
      :to="href"
      :class="params.classes"
      :aria-label="`Link to ${href}`"
    >
      {{ text }}
    </router-link>

    <a
      v-else
      :id="uid"
      :class="params.classes"
      :href="href"
      :target="params.shouldOpenInNewTab ? '_blank' : ''"
      :rel="params.shouldOpenInNewTab ? 'noopener' : ''"
      :aria-label="`Link to ${href}`"
    >{{ text }}</a>
  </span>
</template>

<script setup>
import { computed, onMounted, ref, toRefs } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const href = ref('')
const uid = ref('')

const text = computed(() => {
  if (params.value.linkTextFromField) return params.value.data[params.value.linkTextFromField]
  return params.value.text || ''
})

onMounted(() => {
  if (params.value.to) {
    href.value = params.value.to
  } else if (params.value?.urlTemplate && params.value.value) {
    const decodedUrlTemplate = decodeURI(params.value.urlTemplate)
    href.value = decodedUrlTemplate.replace('${}', params.value.value)
  } else if (params.value.urlFromField) {
    href.value = params.value.data[params.value.urlFromField]
  } else if (params.value.url) {
    href.value = params.value.url
  } else {
    console.warn('Missing cellRendererParams configured for LinkCellRenderer. Please define a urlTemplate, urlFromField, or url parameter in the columnDef in the override.\n\nparams: ', Object.assign({}, params.value))
  }

  uid.value = `ag-grid-cell-renderer-LinkCellRenderer-row-index-${params.value.rowIndex}`
  params.value.eGridCell.setAttribute('aria-labelledby', uid)

  params.value.eGridCell.addEventListener('keyup', (event) => {
    if (event.key === 'Enter') {
      window.location.href = href.value
    }
  })
})
</script>
